import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./fontes.css";
import { App } from "./App";

// Depois de uma publicação nova, uma aba aberta antes dela ainda aponta para os arquivos antigos (com outro hash),
// que deixam de existir: ao falhar o carregamento de um trecho do sistema (ex.: o gerador de PDF), recarrega a página
// uma vez para pegar a versão atual. A marca evita recarregar em laço se o problema for outro.
window.addEventListener("vite:preloadError", (evento) => {
  const chave = "sobral.recarregado_em";
  let ultima = 0;
  try {
    ultima = Number(sessionStorage.getItem(chave) ?? 0);
    if (Date.now() - ultima > 30_000) sessionStorage.setItem(chave, String(Date.now()));
  } catch {
    // Sem sessionStorage: recarrega mesmo assim (o navegador não entra em laço porque a versão nova não falha).
  }
  if (Date.now() - ultima > 30_000) {
    evento.preventDefault();
    window.location.reload();
  }
});

const raiz = document.getElementById("root");
if (!raiz) throw new Error("Elemento #root não encontrado em index.html");

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
